const targetWrapper = document.getElementById("section-brand-wrapper");
const target1 = document.getElementById("section-brand-header");
const target2 = document.getElementById("section-brand-header-2");
const target3 = document.getElementById("section-brand-subheader");

const counter = (entries) => {
  if (entries[0].isIntersecting) {
    let target1Text = 0;
    let target2Text = 0;
    let target3Text = 0;
    const intervalOne = setInterval(() => {
      target1.innerHTML = ++target1Text;
      if (target1Text === 200) {
        clearInterval(intervalOne);
      }
      observer.unobserve(targetWrapper);
    }, 7);
    const intervalTwo = setInterval(() => {
      target2.innerHTML = ++target2Text;
      if (target2Text === 146) {
        clearInterval(intervalTwo);
      }
      observer.unobserve(targetWrapper);
    }, 10);
    const intervalThree = setInterval(() => {
      target3.innerHTML = ++target3Text;
      if (target3Text === 10) {
        clearInterval(intervalThree);
      }
      observer.unobserve(targetWrapper);
    }, 150);
  }
};

const options = { threshold: 0.2 };

const observer = new IntersectionObserver(counter, options);
observer.observe(targetWrapper);
